import { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectIsSandboxUser } from 'features/auth/authenticationSlice';

interface AuthenticationStatusProps {
  isAuthenticating: boolean;
  authenticationStatusLoading: boolean;
  authenticationStatusFetching: boolean;
  authenticationStatus?: {
    isAuthenticated: boolean;
  };
  buttonLogoSrc?: string;
  platform?: string;
  onLogin: () => void;
}

const AuthenticationStatus: FC<AuthenticationStatusProps> = ({
  isAuthenticating,
  authenticationStatusLoading,
  authenticationStatusFetching,
  authenticationStatus,
  buttonLogoSrc,
  platform,
  onLogin
}) => {
  const isSandboxUser = useSelector(selectIsSandboxUser);
  return (
    <>
      <div className="flex items-center gap-2">
        {isAuthenticating || authenticationStatusFetching ? (
          <>
            <i className="text-sm text-primary-400" />
            <p className="text-sm mb-1 text-primary-400 capitalize">
              Authenticating...
            </p>
          </>
        ) : authenticationStatus?.isAuthenticated ? (
          <>
            <i className="text-sm text-tertiary-600 ra-icons-generic-check" />
            <p className="text-sm mb-1 text-tertiary-600 capitalize">
              Authentication Succeeded
            </p>
          </>
        ) : (
          <>
            <i className="text-sm text-error-300 ra-icons-generic-cross" />
            <p className="text-sm mb-1 text-error-300 capitalize">
              Not Authenticated
            </p>
          </>
        )}
      </div>

      <div className="flex items-center justify-center">
        <button
          onClick={onLogin}
          className="border rounded p-2 text-sm border-neutral-200 shadow-lg shadow-secondary-200/10 text-center h-[60px] w-[250px] flex items-center justify-center gap-2 hover:bg-neutral-100 transition duration-200 -mt-4"
          disabled={isAuthenticating || isSandboxUser}
        >
          <img
            src={buttonLogoSrc ?? ''}
            alt={platform ?? 'Platform'}
            className="h-5"
          />
          <span className="text-sm">
            {authenticationStatusLoading ||
            isAuthenticating ||
            authenticationStatusFetching
              ? 'Checking status...'
              : authenticationStatus?.isAuthenticated
              ? `Re-Authenticate with ${platform ?? 'platform'}`
              : `Authenticate with ${platform ?? 'platform'}`}
          </span>
        </button>
      </div>
    </>
  );
};

export default AuthenticationStatus;
